import React from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './ShowMeButton.messages.tsx';

const ShowMeButton = ({ onClick }: { onClick: () => void }): React.ReactNode => {
	const { formatMessage } = useIntl();

	return (
		<Button appearance="discovery" onClick={onClick}>
			{formatMessage(messages.showMeButton)}
		</Button>
	);
};

export default ShowMeButton;
